"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "22", height: "19", viewBox: "0 0 22 19", className: "Icon tick", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement(
            "g",
            { fill: "none", fillRule: "evenodd" },
            _react2.default.createElement("path", { fill: "#FFF", d: "M9.414 16.828L8 18.243l-1.414-1.415-4.707-4.707-1.415-1.414L1.88 9.293l1.414-1.414 1.412-1.412 1.414 1.41 3.293 3.282-2.825.001 9.292-9.282L17.294.465l1.413 1.414 1.414 1.414 1.415 1.414-1.415 1.414z" }),
            _react2.default.createElement("path", { fill: "#B5B5B5", d: "M8 15.414L18.707 4.707l-1.414-1.414L8 12.575 4.707 9.293l-1.414 1.414z", className: "tick-line" })
        )
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/large/jsx/tick.js
// module id = 1827
// module chunks = 0